import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import thunk from 'redux-thunk'
import app from './reducers'
import { historyMiddleware } from './Middlewares/History.middleware'
import ReadMoreScroll from "./Shared/ReadMoreScroll";
import MiniCartContainer from './Containers/MiniCart.container'
import QuickSearchContainer from './Containers/QuickSearch.container'
import NavigationContainer from './Containers/Navigation.container'
import FacetedSearchContainer from './Containers/FacetedSearch.container'
import FacetedSearchCompactContainer from './Containers/FacetedSearchCompact.container'
import NotificationContainer from './Containers/Notification.container'
import DynamicComponent from './Components/DynamicComponent'
import ResellerGoogleMapContainer from "./Muurikka/ResellerGoogleMap.container"
import VariantChooser from "./Muurikka/VariantChooser.container"
import { trackCheckout, trackPurchase, trackViewItem } from './Shared/Tracking';
import MiscellaneousMenu from './Components/MiscellaneousMenu';
import FreeGift from './Muurikka/FreeGift.container';
import './Shared/SearchOtherHitsShowMore';
import DeveloperTools from "./Shared/dev";
import { InitializeHeroWrapperHandler } from "./Shared/HeroWrapperMediaHandler";
import './Muurikka/Vanilla/CheckoutHelper';
import SimpleCollapseVanilla from "./Shared/SimpleCollapse";
import Modal from "./Muurikka/Components/Modal";

document.addEventListener('DOMContentLoaded', () => {
    new DeveloperTools();
    new InitializeHeroWrapperHandler();
});

window.__litium = window.__litium || {};
const preloadState = window.__litium.preloadState || {};

// use the parent page's store if possible, so the iframe will share the same store with the parent context.
// this to makes for example the Reorder button in My Page page to update the state and reload the mini cart
// when reorder action happens.
const store = window.__litium.store = window.__litium.store || (window.parent.__litium && window.parent.__litium.store)
    || createStore(app, preloadState, composeWithDevTools(applyMiddleware(thunk, historyMiddleware)));

// register redux's actions so we can invoke them from vanilla JS
// usage: window.__litium.reduxActions.addToCart(...);
window.__litium = {
    ...window.__litium,
    tracking: {
        trackViewItem,
        trackCheckout,
        trackPurchase
    },
    onSearchResultDataChange: dom => {
        let temp = document.createElement('div')
        temp.innerHTML = dom
        const currentResult = document.querySelector('#search-result')
        const newResult = temp.querySelector('#search-result')
        //move facetSearchCompact from currentResult to newResult
        newResult.replaceChild(
            currentResult.querySelector('#facetedSearchCompact'),
            newResult.querySelector('#facetedSearchCompact')
        )
        //replace currentResult with newResult
        currentResult.parentNode.replaceChild(newResult, currentResult)
    },
    bootstrapComponents: () => {
        // bootstrap React components, in case the HTML response we receive from the server
        // has React components. ReactDOM.render performs only an update on previous rendered
        // components and only mutate the DOM as necessary to reflect latest React element.
        bootstrapComponents();
    },
    cache: {}, // for storing cache data for current request
};

const bootstrapComponents = () => {
    if (document.getElementById('mini-cart')) {
        ReactDOM.render(
            <Provider store={store}>
                <MiniCartContainer icon={false}/>
            </Provider>,
            document.getElementById('mini-cart')
        );
    }

    if (document.querySelector("#muha-modal") && document.querySelector('template#modal-content')) {
        const template = document.getElementById('modal-content');
        const modalContentHtml = template && template.innerHTML;

        ReactDOM.render(
            <Provider store={store}>
                <Modal content={modalContentHtml} />
            </Provider>,
            document.querySelector("#muha-modal")
        );
    }

    if (document.getElementById('mini-cart-icon')) {
        ReactDOM.render(
            <Provider store={store}>
                <MiniCartContainer icon={true}/>
            </Provider>,
            document.getElementById('mini-cart-icon')
        );
    }

    let productPageBuyButtonsEl = document.querySelectorAll('.product-page-buy-buttons:not(.react-rendered)');
    if (productPageBuyButtonsEl.length) {
        const ProductPageBuyButtons = DynamicComponent({
            loader: () => import('./Containers/ProductPageBuyButtons.container')
        });
        productPageBuyButtonsEl.forEach((buyButtonsEl) => {
            ReactDOM.render(
                <Provider store={store}>
                    <ProductPageBuyButtons
                        isMuurikka={!!+buyButtonsEl.dataset.isMuurikka}
                        isProductPage={!!+buyButtonsEl.dataset.isProductPage}
                        productItem={JSON.parse(buyButtonsEl.dataset.productItem)}
                        openMiniCartAtCheckout={true}
                    />
                </Provider>,
                buyButtonsEl
            );
        });
    }

    if (document.getElementById('quick-search')) {
        ReactDOM.render(
            <Provider store={store}>
                <QuickSearchContainer isMuurikka={true}/>
            </Provider>,
            document.getElementById('quick-search')
        );
    }

    if (document.getElementById('navbar')) {
        ReactDOM.render(
            <Provider store={store}>
                <NavigationContainer/>
            </Provider>,
            document.getElementById('navbar')
        );
    }

    if (document.getElementById('facetedSearch')) {
        ReactDOM.render(
            <Provider store={store}>
                <FacetedSearchContainer/>
            </Provider>,
            document.getElementById('facetedSearch')
        );
    }

    if (document.getElementById('facetedSearchCompact')) {
        ReactDOM.render(
            <Provider store={store}>
                <FacetedSearchCompactContainer/>
            </Provider>,
            document.getElementById('facetedSearchCompact')
        );
    }

    if (document.getElementById('globalNotification')) {
        ReactDOM.render(
            <Provider store={store}>
                <NotificationContainer/>
            </Provider>,
            document.getElementById('globalNotification')
        );
    }

    if (document.getElementById('myPagePersons')) {
        const PersonList = DynamicComponent({
            loader: () => import('./Containers/PersonList.container')
        });
        ReactDOM.render(
            <Provider store={store}>
                <PersonList/>
            </Provider>,
            document.getElementById('myPagePersons')
        );
    }

    if (document.getElementById('myPageAddresses')) {
        const AddressList = DynamicComponent({
            loader: () => import('./Containers/AddressList.container')
        });
        ReactDOM.render(
            <Provider store={store}>
                <AddressList/>
            </Provider>,
            document.getElementById('myPageAddresses')
        );
    }

    if (document.getElementById('checkout')) {
        const Checkout = DynamicComponent({
            loader: () => import('./Containers/Checkout.container')
        });
        ReactDOM.render(
            <Provider store={store}>
                <Checkout/>
            </Provider>,
            document.getElementById('checkout')
        );
    }

    if (document.getElementById('lightBoxImages')) {
        const LightboxImages = DynamicComponent({
            loader: () => import('./Muurikka/Containers/LightboxImages.container')
        });

        const rootElement = document.getElementById('lightBoxImages');
        let mediaItems = Array.from(rootElement.querySelectorAll('a')).map(anchor => {
            return {
                fullSrc: anchor.dataset.src,
                previewSrc: anchor.dataset.previewSrc,
                thumbnailSrc: anchor.dataset.thumbnailSrc,
                type: anchor.dataset.type,
                alt: anchor.dataset.alt || '',
                mimeType: anchor.dataset.mime,
            }
        });

        const productLabelsTemplate = rootElement.querySelector('#product-labels-template');
        const productLabelsHtml = productLabelsTemplate && productLabelsTemplate.innerHTML;

        ReactDOM.render(
            <Provider store={store}>
                <LightboxImages mediaItems={mediaItems} productLabelsHtml={productLabelsHtml}/>
            </Provider>,
            document.getElementById('lightBoxImages')
        );
    }

    if (document.querySelectorAll('.slider').length > 0) {
        const Slider = DynamicComponent({
            loader: () => import('./Components/Slider')
        });
        Array.from(document.querySelectorAll('.slider')).forEach((slider, index) => {
            const values = [...slider.querySelectorAll('.slider__block')].map(block => {
                return ({
                    image: block.dataset.image,
                    url: block.dataset.url,
                    text: block.dataset.text,
                })
            });
            if (values.length > 0) {
                ReactDOM.render(
                    <Slider values={values}/>,
                    slider
                );
            }
        });
    }

    let buyButtonEls = document.querySelectorAll('buy-button');
    if (buyButtonEls.length) {
        const BuyButton = DynamicComponent({
            loader: () => import('./Containers/BuyButton.container')
        });
        buyButtonEls.forEach((button) => {
            const {articleNumber, quantityFieldId, jsonTrackingProduct, href, cssClass} = button.dataset;
            const label = button.innerText;
            let trackingProduct
            if (jsonTrackingProduct !== undefined) {
                trackingProduct = JSON.parse(jsonTrackingProduct);
            }
            ReactDOM.render(
                <Provider store={store}>
                    <BuyButton {...{label, articleNumber, quantityFieldId, trackingProduct, href, cssClass}} />
                </Provider>,
                button
            );
        });
    }

    if (document.querySelectorAll('reorder-button').length > 0) {
        const ReorderButton = DynamicComponent({
            loader: () => import('./Containers/ReorderButton.container')
        });
        Array.from(document.querySelectorAll('reorder-button')).forEach((button) => {
            const {cssClass, orderId, title} = button.dataset;
            const label = button.innerText;
            ReactDOM.render(
                <Provider store={store}>
                    <ReorderButton {...{label, title, cssClass, orderId}} />
                </Provider>,
                button
            );
        });
    }

    if (document.getElementById('resellerGoogleMap')) {
        ReactDOM.render(
            <Provider store={store}>
                <ResellerGoogleMapContainer/>
            </Provider>,
            document.getElementById('resellerGoogleMap')
        )
    }

    //  if (document.getElementById('ResellerGoogleMapForProduct')) {
    //   ReactDOM.render(
    //     <Provider store={store}>
    //       <ResellerGoogleMapForProductContainer />
    //     </Provider>,
    //     document.getElementById('ResellerGoogleMapForProduct')
    //   )
    // }

    if (document.getElementById('variantChooser')) {
        ReactDOM.render(
            <Provider store={store}>
                <VariantChooser/>
            </Provider>,
            document.getElementById('variantChooser')
        )
    }

    let resellerProductEl = document.querySelectorAll('.reseller-product');
    if (resellerProductEl.length) {
        const ResellerProduct = DynamicComponent({
            loader: () => import('./Muurikka/ResellerGoogleMapForProduct.container')
        });

        resellerProductEl.forEach((resellerProduct) => {
            ReactDOM.render(
                <Provider store={store}>
                    <ResellerProduct
                        variantId={resellerProduct.dataset.variantId}
                        isGlobalChannel={resellerProduct.dataset.isglobalchannel}
                    />
                </Provider>,
                resellerProduct
            );
        });
    }

    let findResellerStoresButtons = document.querySelectorAll('.find-reseller-stores-button');
    if (findResellerStoresButtons.length) {
        const FindResellerStoresButton = DynamicComponent({
            loader: () => import('./Containers/FindResellerStoresButton.container')
        });
        findResellerStoresButtons.forEach((findResellerButton) => {
            ReactDOM.render(
                <Provider store={store}>
                    <FindResellerStoresButton isMuurikka={!!+findResellerButton.dataset.isMuurikka} />
                </Provider>,
                findResellerButton
            );
        });
    }

    if (document.getElementById('miscellaneous-menu-btn')) {
        ReactDOM.render(
            <Provider store={store}>
                <MiscellaneousMenu />
            </Provider>,
            document.getElementById('miscellaneous-menu-btn')
        )
    }

    let freeGiftElement = document.getElementById('free-gift');
    if (freeGiftElement) {
        const campaignText = freeGiftElement.dataset.campaignText; 
        ReactDOM.render(
            <Provider store={store}>
                <FreeGift campaignText={campaignText} />
            </Provider>,
            freeGiftElement
        );
    }

    document.addEventListener('DOMContentLoaded', function() {
        var breadcrumb = document.querySelector('#breadcrumbs-container .breadcrumbs');
        if (breadcrumb) {
            breadcrumb.scrollLeft = breadcrumb.scrollWidth;
            breadcrumb.style.visibility = 'visible';
        }
    });

    new ReadMoreScroll();
    new SimpleCollapseVanilla();

    const body = document.querySelector('body');
    const stickyEl = document.querySelector('.product-page-buy-buttons');

    function determineIfBuyButtonIsSticky() {
        if (!stickyEl) return;
        const rect = stickyEl.getBoundingClientRect();

        const isStuck = Math.abs(window.innerHeight - rect.bottom - 11) < 1; // 8px = 0.5rem
        body.classList.toggle('buy-button-is-sticky', isStuck);
    }

    window.addEventListener('scroll', determineIfBuyButtonIsSticky);
    window.addEventListener('resize', determineIfBuyButtonIsSticky);
}

bootstrapComponents();

window.addEventListener('pageshow', (event) => {
    if (event.persisted && document.getElementById('checkout')) {
        window.location.reload();
    }
});
